module.exports = __webpack_public_path__ + "static/media/personicon.5b00ea74.svg";